import styled from 'styled-components';
import is from 'styled-is';
import StageEstimatedTime from './container';

import { Z_INDEX } from 'modules/journey/stop-status-log/z-index';

export default styled(StageEstimatedTime)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 2px solid var(--grey100);
  border-left: 2px solid var(--grey100);
  color: var(--grey500);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${Z_INDEX.ETA};
  background: #fff;
  transition: transform 0.3s ease-in-out;

  ${is('over', 'clickable')`
    transform: translateY(-50%);
  `}

  ${is('opened')`
    transform: translateY(-100%);
  `}
`;
